import axios from "../../../../../../api/axiosInstance";
import { FetchProductStoreCategoryMetadataResponse } from "./types";

export const fetchProductStoreCategoryMetadata =
  async (): Promise<FetchProductStoreCategoryMetadataResponse> => {
    const response = await axios.get<FetchProductStoreCategoryMetadataResponse>(
      "/api/private/product-store/categories/metadata",
    );
    return response.data;
  };
